/**
 * Description: Filter Audit Batch Component on review page
 */
import React from 'react';
import {
  Input,
  FormSection,
  Select,
  ColumnLayout
} from 'AWS-UI-Components-React';
import { FilterCommon } from '../filterSection.jsx';
import '../../styles/filterSection.css';

const AUDIT_STATUS = [
  {
    "label": "Accepted",
    "id": "Accepted"
  },
  {
    "label": "Auto Accepted",
    "id": "Auto Accepted"
  },
  {
    "label": "Partially Accepted",
    "id": "Partially Accepted"
  },
  {
    "label": "Rejected",
    "id": "Rejected"
  }
];

export class FilterAuditedOutfits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_options: {
        outfit_id: "",
        outfit_source: "",
        after_date: "",
        before_date: "",
        user: "",
        audit_status: "Accepted",
        next_token: "",
        marketplace: "0",
        seed_category: ""
      }
    };
    this.filterCallback = this.filterCallback.bind(this);
  }

  filterCallback(common_options) {
    this.state.filter_options.outfit_source = common_options.outfit_source;
    this.state.filter_options.after_date = common_options.after_date;
    this.state.filter_options.before_date = common_options.before_date;
    this.state.filter_options.next_token = "";
    this.state.filter_options.marketplace = common_options.marketplace;
    this.state.filter_options.seed_category = common_options.seed_category;

    return this.props.getAuditedOutfitsCallback(this.state.filter_options);
  }

  render() {
    const FilterOutfits = () => (
      <div>
        Audit Status:
        <Select 
          options={AUDIT_STATUS}
          enableFiltering={true}
          selectedId={!!(this.state.filter_options.audit_status)?this.state.filter_options.audit_status:"Accepted"}
          onChange={ (event) => {
            this.state.filter_options.audit_status = event.detail.selectedId;
          }
        }
        ></Select>

        User (alias):
        <Input
          onChange={(event) => {
            this.state.filter_options.user = event.detail.value;
          }
        }/>
      </div>
    );
    
    const FilterOutfit = () => (
      <div>
        Filter by Outfit id:
        <Input
          placeholder="ex. 47ea3c5b-bb36-4d01-b33c-0398e"
          onChange={(event) => {
            this.state.filter_options.outfit_id = event.detail.value;
          }
        }/>
      </div>
    );
    
    const filter_labels = {
      after_date: "Audited After (inclusive):",
      before_date: "Audited Before (inclusive):",
      button_text: "View Audited Outfits"
    }

    return (
      <div className="awsui">
        <div>
          <FormSection header="Filter Outfits" expandable={true} expanded={true}>
            <ColumnLayout columns={4}>
              <div data-awsui-column-layout-root="true" className="filter-options">
                <div>
                  <FilterCommon filter_labels={filter_labels} filterCallback={this.filterCallback} />
                </div> 
                <div>
                  <FilterOutfits/>
                </div>
                <div style={{fontWeight: "bold", fontSize: 20, textAlign: "center"}}>
                  OR
                </div>
                <div>
                  <FilterOutfit/>
                </div>   
              </div>
            </ColumnLayout>
          </FormSection>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/browsePage/filterAuditedOutfitsSection.jsx